import axios from 'axios'
import { CADASTRAR_AGENDAMENTO_VIAGEM } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';

export default function cadastrarAgendamentoViagem (agendamento) {
  const url = `${URL}/agendamento-viagem/cadastrar`;
  return dispatch => axios.post(url, agendamento, SLOW_REQUEST_CONFIG).then(
      response => dispatch({
        type: CADASTRAR_AGENDAMENTO_VIAGEM,
        payload: response
      })
  );
}
